import React from 'react';
import styled from 'styled-components/macro';

type ProgressBarProps = {
  value: number;
  trackColor?: string;
  baseColor?: string;
};

export const ProgressBar = ({
  value,
  trackColor = 'var(--cogs-greyscale-grey5)',
  baseColor = 'var(--cogs-greyscale-grey3)',
}: ProgressBarProps) => (
  <StyledProgressBar
    value={value}
    trackColor={trackColor}
    baseColor={baseColor}
  />
);

const StyledProgressBar = styled.div<ProgressBarProps>`
  position: relative;
  height: 5px;
  width: 100%;
  border-radius: 5px;

  ${(props) =>
    `
    background: ${props.baseColor};
    &:after {
        content: '';
        width: ${props.value || 0}%;
        position: absolute;
        border-radius: 5px;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: ${props.trackColor};
      }
  `};
`;
